<div inView (inView)="onAppear($event)" class="container section-gap">
  <div class="col-lg-12">
    <kla-title
      [lineConfig]="lineConfig"
      [config]="config.title"
      [showFooter]="false"
    ></kla-title>
  </div>
  <div class="col-12 below-chart-holder" #panel>
    <div *ngIf="!configHighchart" class="row chart spinner-container">
      <div class="chart-position cm-spinner"></div>
    </div>
    <div *ngIf="configHighchart" class="row chart" >
      <kla-highchart
        class="chart-position"
        [chartType]="chartType"
        [config]="configHighchart"
        [attr.role]="config?.chartAltText ? 'img' : null"
        [attr.aria-label]="config?.chartAltText || null"
      ></kla-highchart>
    </div>
  </div>
  <div class="col-12">
    <div
      class="text-center footer-paragraph"
      *ngIf="config?.title?.footer"
    >
    <app-dynamic-content
      [contentId]="'below-highchart-footer'"
      [htmlContent]="config.title.footer">
    </app-dynamic-content>
    </div>
  </div>
</div>
